export const SET_SLIDE_BREAK = "SET_SLIDE_BREAK";
export const SET_SLIDE_DATA = "SET_SLIDE_DATA";
export const SET_ADD_TO_SLIDE = "SET_ADD_TO_SLIDE";
export const SET_DATA = "SET_DATA";
export const SET_GNERATE_DATA = "SET_GNERATE_DATA";
export const FETCHING_SLIDE_INIT = "FETCHING_SLIDE_INIT";

const initialState = {
  isInsights: false,
  isDataLoading: true,
  generated_report_list_refetch: false,
  view_generated_page: 1,
  report_per_page: 10,
  total_reports: 0,
  disabledSubmitButton: true,
  isSubmitted: false,

  isReportLoading: false,
  generatedReports: [],

  new_email: "",
  new_phone_number: "",
  new_job_title: "",
  account_manager_name: "",

  slides: [],
  formated_ans: {},
  new_slide: {},
  bgImage: "",
  isImg: false,
  I_file: null,

  sPage: 1,
  loadDataAccess: true,
  dataLoadAccess: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_DATA:
      return { ...state, ...action.payload };
    case SET_SLIDE_DATA:
      const { id, value } = action.payload;
      return {
        ...state,
        slides: state.slides.map((item) => {
          if (item.id == id) {
            return { ...item, data: value };
          }
          return item;
        }),
      };
    case SET_ADD_TO_SLIDE:
      const { slug, boolean } = action.payload;
      return {
        ...state,
        slides: state.slides.map((item) => {
          if (item.slug == slug) {
            return { ...item, add_to_slide: boolean };
          }
          return item;
        }),
      };
    case SET_SLIDE_BREAK: {
      return {
        ...state,
        new_slide: {
          ...state.new_slide,
          [action.payload.name]: action.payload.value,
        },
      };
    }
    case FETCHING_SLIDE_INIT: {
      return {
        ...state,
        new_email: "",
        new_phone_number: "",
        new_job_title: "",
        account_manager_name: "",
        bgImage: "",
        isImg: false,
        I_file: null,
        slides: [],
      };
    }
    default:
      return state;
  }
};
